<template>
  <div>
    <div id="firebaseui-auth-container" class="w-100"></div>
  </div>
</template>
<script>
import firebase from "firebase";
import firebaseui from "firebaseui";
import "../node_modules/firebaseui/dist/firebaseui.css";

export default {
  mounted() {
    let uiConfig = {
      signInOptions: [
        {
          provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID
        }
      ]
    };
    var ui = new firebaseui.auth.AuthUI(firebase.auth());
    ui.start("#firebaseui-auth-container", uiConfig);
  }
};
</script>
